import SessionEventProto from "../session-event-proto";


export default class EventCompanyUsersReset extends SessionEventProto {


    process() {
        if (this.isDifferentCompany()) return false;

        gd.session.companyUsers.resetAndMarkOldModelsAsDeleted(this.data)
    }
};

// module.exports = class EventCompanyUsersReset extends EventActionProto {
//
//     constructor(uid, data) {
//         super(uid, data)
//     }
//
//     validate() {
//         return true
//     }
//
//     process() {
//         gd.session.companyUsers.resetAndMarkOldModelsAsDeleted(this.data,{parse:true})
//
//         super.process()
//     }
// }

